<template>
  <section class="form-card">
    <header v-if="$slots.header || header" class="form-card__header">
      <slot name="header">{{ header }}</slot>
    </header>

    <div class="form-card__body">
      <slot />
    </div>

    <footer v-if="$slots.footer" class="form-card__footer">
      <slot name="footer" />
    </footer>
  </section>
</template>

<script>
export default {
  name: "FormCard",
  props: {
    // 단순 텍스트 제목. 아이콘/설명 등 더 풍부한 헤더가 필요하면 #header 슬롯을 쓴다.
    header: { type: String, default: "" },
  },
};
</script>

<style scoped>
.form-card {
  background: var(--bg-surface);
  border: 1px solid var(--border-default);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-sm);
  padding: var(--space-6);
  display: flex;
  flex-direction: column;
}

.form-card__header {
  font-size: var(--font-h3-size);
  line-height: var(--font-h3-line);
  font-weight: var(--font-h3-weight);
  color: var(--text-primary);
  margin-bottom: var(--space-4);
}

.form-card__body {
  flex: 1;
  min-width: 0;
}

.form-card__footer {
  display: flex;
  justify-content: flex-end;
  gap: var(--space-2);
  margin-top: var(--space-6);
  padding-top: var(--space-6);
  border-top: 1px solid var(--border-default);
}
</style>
